<div class="container-fluid">
  <h1 mat-dialog-title>Task Query Selector</h1>
  <div mat-dialog-content>
    <div title="Items Selector-TFS Queries" class="modal-header">
      <h4 class="modal-title font-color-navy bold-text">Items Selector-ADS Queries for {{data.project}}</h4>
    </div>
    <div class="modal-body">
      <span *ngIf="isListloading" class="justify-content-center">
        <app-loading [displayeMessage]="true"></app-loading>
      </span>
      <div class="form-inline">
        <div class="row">
          <div class="col-md-2 font-color-navy bold-text"><label for="querySelector">Select a query</label></div>
          <div class="col-md-9">
            <select #querySelector class="form-control" name="query" (change)="selectQuery(querySelector.value)" required>
              <option *ngFor="let queryItem of queries" [value]="queryItem.id">{{queryItem.path}}</option>
            </select>
          </div>
          <div class="col-md-1">
            <button id="run-query-button" type="button" style="height:75%;padding-top:3px;"
                    [ngClass]="enableRun ? 'btn-new-ui':'btn-new-ui-disabled'" [disabled]="!enableRun" (click)="runQuery()">
              Run
            </button>
          </div>
          <span *ngIf="isQueryRunning">
            <app-loading [displayeMessage]="false"></app-loading>
          </span>
        </div>
      </div>
      <div class="form-group">
        <table id="selectable-items" class="table">
          <thead>
            <tr>
              <th><input type="checkbox" [checked]="isAllCheckBoxChecked()" (change)="checkAllCheckBox($event)"></th>
              <th>#</th>
              <th>Type</th>
              <th>Title</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let task of queryTaskList; index as i" [attr.id]="task.id">
              <td><input type="checkbox" name="taskCheck" value="{{task.id}}" [(ngModel)]="queryTaskList[i].checked" (click)="onSelectTask(task)"></td>
              <td>{{task.id}}</td>
              <td>{{task.shortType}}</td>
              <td>{{task.title}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="errors" class="text-danger text-center">
      </div>
    </div>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onCloseClick()">Close</button>
    <button mat-button [mat-dialog-close]="data.selectedTasks" cdkFocusInitial>Add Selected Items</button>
  </div>
</div>

